export default __webpack_public_path__ + "static/media/note-icon.36d60173.png";